import { BreadrumbComponent } from '@model/content';
import { Breadcrumb } from '@components/common/breadcrumb';
import { DestinationLinkBuilder } from '@model/iceberg';

export const BreadcrumbContainer = ({ breadcrumbs, tripType }: BreadrumbComponent) => {
  let items;
  if (tripType) {
    const linkBuilder: DestinationLinkBuilder = new DestinationLinkBuilder();
    items = breadcrumbs?.map(({ path, display }) => {
      const link = linkBuilder.getDestinationLink(path, tripType);
      return {
        display,
        ...link
      };
    });
  } else {
    items = breadcrumbs?.map(({ path, display }) => {
      return {
        display,
        href: `/${path}`
      };
    });
  }

  if (!items) {
    return null;
  }

  return <Breadcrumb items={items} />;
};
